<div class="templates-list" *ngIf="templates.length && !editMode">
  <div class="template-item" *ngFor="let template of templates; index as i">
    <div class="template-info">
      <div *ngIf="template.name" class="template-text">
        <span>{{ template.name }}</span>
        <small>{{ template.updated_at | date: 'dd/MM/yyyy hh:mm' }}</small>
      </div>
      <div class="color-bullets">
        <div class="color-bullets-section">
          <span
            class="bullet"
            [ngStyle]="{ 'background-color': template.values.header.background }"
            title="Header: Background"></span>
          <span
            class="bullet"
            [ngStyle]="{ 'background-color': template.values.header.title }"
            title="Header: Main title"></span>
          <span
            class="bullet"
            [ngStyle]="{ 'background-color': template.values.header.subtitle }"
            title="Header: Secondary title"></span>
        </div>
        <div class="color-bullets-section">
          <span
            class="bullet"
            [ngStyle]="{ 'background-color': template.values.topbar.background }"
            title="Topbar: Background"></span>
          <span
            class="bullet"
            [ngStyle]="{ 'background-color': template.values.topbar.text }"
            title="Topbar: Text"></span>
        </div>
        <div class="color-bullets-section">
          <span
            class="bullet"
            [ngStyle]="{ 'background-color': template.values.externalbtn.background }"
            title="External button: background"></span>
          <span
            class="bullet"
            [ngStyle]="{ 'background-color': template.values.externalbtn.text }"
            title="External button: text"></span>
        </div>
        <div class="color-bullets-section">
          <span
            class="bullet"
            [ngStyle]="{ 'background-color': template.values.popups.background }"
            title="Popup: Background"></span>
          <span class="bullet" [ngStyle]="{ 'background-color': template.values.popups.tag }" title="Popup: Tag"></span>
          <span
            class="bullet"
            [ngStyle]="{ 'background-color': template.values.popups.value }"
            title="Popup: Value"></span>
        </div>
      </div>
    </div>
    <div class="template-btns">
      <button
        title="Aplicar plantilla"
        class="action-btn"
        [ngClass]="{ active: editMode && editMode.id === template.id }"
        (click)="applyTemplate(template)">
        <img id="delete" alt="" />
      </button>
      <button
        title="Editar plantilla"
        class="action-btn"
        [ngClass]="{ active: editMode && editMode.id === template.id }"
        (click)="editTemplate(template)">
        <img id="edit" alt="" />
      </button>
    </div>
  </div>
</div>
<div *ngIf="editMode">
  <div class="editmode-header">
    <div class="d-flex align-items-center justify-content-between">
      <span>Editar plantilla</span>
      <button class="btn-secondary-action" (click)="editMode = null">Volver</button>
    </div>
    <input type="text" class="custom-input" [(ngModel)]="editMode.name" />
  </div>
  <div>
    <app-color-custom
      #customtemplate
      [custom_colors]="editMode.values"
      [template]="true"
      (onTemplateDestroy)="onDestroyTemplate()"
      (onTemplateUpdate)="onUpdatedTemplate($event)"></app-color-custom>
  </div>
</div>
